import React from 'react';
import Layout from '../components/Layout';

import AboutLayout1 from '../components/aboutusheader';
import ScrollingText from '../components/lettersslider';
import LegalBriefComponent from '../components/aboutusinfo';
import TeamComponent from '../components/aboutusdetails';

const AboutUs: React.FC = () => {
  return (
    <Layout>
      <AboutLayout1/>
      <ScrollingText/>
      <LegalBriefComponent/>
      <TeamComponent/>

    </Layout>
  );
}

export default AboutUs;
